import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { LotsManagementNewCrumbs } from 'front-office/constants/lots-management-crumbs';
import { Card, CardActions, CardContent, Typography, useEventCallback } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FormNew from 'front-office/components/lots-management/new';
import { Form, Formik } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { validationSchemaNew } from 'front-office/constants/lots-management-schema';
import { LotsManagementNewVM } from 'front-office/view-models/lots-management/new';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';

const LotsManagementNew = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/sportello');
  });

  const register = useHttpClient(
    `${__PERSON_API_URL__}/persona/lotto-carte/assegnazione-nuovo-lotto-cid`,
    {
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
    }
  );

  const onSubmit = useEventCallback((values: LotsManagementNewVM) => {
    const data = {
      key: {
        dataAssegnazione: values.date?.toFormat('yyyyMMdd') || undefined,
        servizio: values.service || undefined,
        operatore: values.operator || undefined,
      },
      numeroInizioLotto: values.fromNumber || undefined,
      numeroFineLotto: values.toNumber || undefined,
    };

    (register({ data }) as ResponsePromise<void>).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello');
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={LotsManagementNewCrumbs} />
      <Card raised className="pmi-my-3">
        <Formik
          validationSchema={validationSchemaNew}
          initialValues={
            {
              fromNumber: undefined,
              toNumber: undefined,
              date: DateTime.now(),
            } as LotsManagementNewVM
          }
          onSubmit={onSubmit}
        >
          <Form>
            <CardContent style={{ padding: '24px' }}>
              <Typography gutterBottom variant="h5" component="h2">
                {"Assegna nuovo lotto carta d'identità"}
              </Typography>
              <div style={{ padding: '24px 0 0 0' }}>
                <FormNew />
              </div>
            </CardContent>
            <CardActions style={{ padding: '24px 24px 16px 24px' }}>
              <PmiButton variant="contained" color="primary" type="submit">
                Conferma
              </PmiButton>
              <PmiButton
                variant="outlined"
                color="cdmBrand"
                onClick={() => {
                  onCancel();
                }}
              >
                Esci
              </PmiButton>
            </CardActions>
          </Form>
        </Formik>
      </Card>
    </Fragment>
  );
};

LotsManagementNew.displayName = 'Lots Management New Page component';

export default LotsManagementNew;
